// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qxar","buttons":"styles_buttons__3GHYs"};